import { render, staticRenderFns } from "./ExportationFrameJumping.vue?vue&type=template&id=0fcb65ce&scoped=true&"
import script from "./ExportationFrameJumping.vue?vue&type=script&lang=js&"
export * from "./ExportationFrameJumping.vue?vue&type=script&lang=js&"
import style0 from "./ExportationFrameJumping.vue?vue&type=style&index=0&id=0fcb65ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcb65ce",
  null
  
)

export default component.exports